import React, {useEffect} from "react";
import {useForm} from "react-hook-form";
import {useDispatch} from "react-redux";
import {
    AddressInput,
    CreateCancelButtons,
    InputMain,
    PhoneInput2,
    SelectMain,
} from "components";
import {
    FindError,
    FindLoad,
    FindSuccess,
    isEmptyObj,
    useModal,
} from "utils";
import {
    facilitiesActions,
    httpRequestsOnErrorsActions,
    httpRequestsOnSuccessActions,
} from "store";
import {FacilityTypesList} from "../constants";
import {Svg} from "assets";

export const AddFacility = ({
                                info, onCancel = () => {
    },closeModal, afterSuccess, customAddRequest
                            }) => {
    const dispatch = useDispatch();
    const {
        handleSubmit,
        control,
        getValues,
        setValue,
        clearErrors,
        setError,
        reset,
    } = useForm();
    const {close} = useModal();
    const ACTION_TYPE = info ? "EDIT_FACILITIES" : "ADD_FACILITIES";
    const loading = FindLoad(ACTION_TYPE);
    const success = FindSuccess(ACTION_TYPE);
    const beckError = FindError(ACTION_TYPE);

    useEffect(() => {
        if (success?.type) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
            afterSuccess();
            close();
        }
    }, [success]);

    useEffect(() => {
        if (info) {
            reset({
                ...info,
            });
        }
    }, [info]);

    useEffect(() => {
        if (beckError?.error?.length) {
            if (beckError?.error?.includes("phone must be a valid phone number")) {
                setError("phone", {
                    message: "Phone must be a valid phone number",
                });
            }
        }
    }, [beckError?.error]);

    useEffect(() => {
        dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
        clearErrors();

        return () => {
            dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
            clearErrors();
        };
    }, []);

    const onSubmit = (data) => {
        const params = {
            ...data,
        };

        if (isEmptyObj(params?.address)) {
            delete params?.address;
        }

        if (customAddRequest) {
            customAddRequest(params)
        } else {
            if (info) {
                dispatch(facilitiesActions.editFacility(info?.id, params));
            } else {
                dispatch(facilitiesActions.addFacility(params));
            }
        }
    };
    return (
        <form
            className="add-facility-modal-wrapper"
            onSubmit={handleSubmit(onSubmit)}
        >
            <div className="modal-header-main">
                <h3 className="modal-header-title">{info ? "Edit" : "Add"} Facility</h3>

                <button className="modal-close-btn-main" type="button" onClick={closeModal || close}>
                    <Svg.CloseSvg/>
                </button>
            </div>

            <div className="modal-body-main">
                <InputMain
                    name="name"
                    placeholder="Ex. Medicare"
                    control={control}
                    labelHeader="Name"
                    rules={{
                        required: "Name is required",
                    }}
                />

                <PhoneInput2
                    label="Phone Number"
                    placeholder={"ex (000) 000-0000"}
                    name="phone"
                    control={control}
                    labelHeader="Phone Number"
                    rules={{
                        minLength: {
                            value: 10,
                            message: "Please enter a valid 10 digit number.",
                        },
                        validate: (value) => {
                            return value
                                ? value?.replace(/[^0-9]/g, "").length === 10 ||
                                "Please enter a valid phone number."
                                : true;
                        },
                    }}
                />

                <SelectMain
                    list={FacilityTypesList}
                    renderLabel={(option) => option?.name}
                    name="type"
                    control={control}
                    placeholder="Select a type"
                    labelHeader="Type"
                    selectedValue={'id'}
                />

                <AddressInput
                    control={control}
                    allValues={getValues()?.address}
                    setValue={setValue}
                />
            </div>

            <CreateCancelButtons
                createText={info ? "Save" : "Add"}
                loading={!!loading?.length}
                onCancel={onCancel}
            />
        </form>
    );
};
